<template>
  <div class="quiz h-screen">
    <div class="container flex flex-wrap m-auto p-2 md:lg:max-w-xl lg:max-w-2xl w-full">
      <div class="w-full text-center pt-2 md:lg:pt-3 lg:pt-4">
        <p class="text-sm md:text-base lg:text-lg text-gray-100 uppercase font-thin">Exclusive test</p>
      </div>
      <transition name="slide-fade" mode="out-in">
        <div :key="questionIndex" v-if="currentState == States.QUIZ" class="flex flex-wrap w-full">
          
          <div class="w-full text-center">
            <p v-if="questionIndex == 0" class="my-5 text-xl md:text-2xl lg:text-3xl font-medium leading-tight text-gray-100">You want to find an online business that suits you <span class='text-highlight font-bold'>100%</span> and works perfectly? <span class='font-bold'>Then answer these short questions right now:</span></p>
            <h1 class="my-5 text-2xl md:text-3xl lg:text-4xl font-bold leading-tight text-gray-100" v-html="questions[questionIndex].question"></h1>
          </div>

          <div v-for="(suggestion, index) in questions[questionIndex].suggestions" :key="index" class="w-1/2 p-1 md:p-2 lg:p-4">
            <QuizButton :id="index" :buttonImage="suggestion.image" :buttonText="suggestion.suggestion" @button-message="handleNextQuestion($event)"/>
          </div>
        </div>
        <Waiting key="currentState" v-if="currentState == States.WAITING" @progress-message="handleProgress()"/>
        <Result key="currentState" v-if="currentState == States.RESULT" :suggestions="getSuggestions()"/>
      </transition>
    </div>
  </div>
  <!-- :class="{'w-1/2':true, 'p-1':true, 'md:p-2':true, 'lg:p-4':true, 'mx-auto':((index == (questions[questionIndex].suggestions.length - 1) && (questions[questionIndex].suggestions.length%2)))}" -->
</template>

<script>
// @ is an alias to /src
import QuizButton from '@/components/QuizButton.vue'
import Waiting from '@/components/Waiting.vue'
import Result from '@/components/Result.vue'

const States = {
  QUIZ: 0,
  WAITING: 1,
  RESULT: 2,
};

export default {
  name: 'Quiz',
  components: {
    QuizButton,
    Waiting,
    Result
  },
  data: function () {
    return {
      questionIndex: 0,
      responses: [],
      States,
      currentState: States.QUIZ,
      endState: States.RESULT
    }
  },
  methods: {
    handleNextQuestion(id) {
      if (this.questionIndex < this.questions.length) {
        this.responses.push(id);
        this.questionIndex++;
      }
      this.stateMachine();
    },
    handleProgress() {
      this.stateMachine();
    },
    getSuggestions() {
      var suggestions = [];
      for (let i = 0; i < this.responses.length; i++) {
        const respond = this.responses[i];
        const suggestion = this.questions[i].suggestions[respond].suggestion;
        suggestions.push(suggestion);
      }
      return suggestions;
    },
    //
    //
    //
    stateMachine() {
      if (this.currentState == this.States.QUIZ) {
        // Quiz State -> Waiting State

        if (this.questionIndex > (this.questions.length-1)) {
          this.currentState = this.States.WAITING
        }
      }else if (this.currentState == this.States.WAITING) {
        // Waiting State -> Result State

        this.currentState = this.States.RESULT
      }else if (this.currentState == this.States.RESULT) {

        // Result State
        console.log("");
      }
    }
  },
  /*mounted() {
    // if back button is pressed
    history.pushState(null, document.title, location.href);
    window.onpopstate = function () {
        window.open("http://bit.ly/fragebogen-resultat","_self");
    };
  },*/
  computed: {
    questions() {
      return this.$store.state.questions;
    }
  }
}
</script>

<style>
  .slide-fade-enter-active {
    transition: all .3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  .slide-fade-enter {
    transform: translateY(-10%);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(10%);
    opacity: 0;
  }
</style>